export default {
  bookmark_post: 'Gem opslag',
  post_bookmarked: 'Opslaget blev gemt',
  post_unbookmarked: 'Opslaget er ikke længere gemt',
  bookmark_post_info:
    'Opslag kan have et udløbstidspunkt. Når dette passeres, forsvinder opslaget automatisk fra gemte opslag',
};
